module.exports = __webpack_public_path__ + "static/media/clube-espaco-atlantico.a20bef63.png";